export const QuestionsReducer = (state, action) => {
  switch (action.type) {
    case "ADD_QUESTIONS":
      let st = state;
      st.questions.push(action.payload);
      return { ...state, questions: st.questions };
    case "SAVE_QUESTIONS":
      state.questions[action.payload.GindexQuestion].GidCategoryQuestion =
        action.payload.GidCategoryQuestion;
      state.questions[action.payload.GindexQuestion].GidQuestion =
        action.payload.GidQuestion;
      state.questions[action.payload.GindexQuestion].GidQuestionSurvey =
        action.payload.GidQuestionSurvey;
      state.questions[action.payload.GindexQuestion].GisEdit =
        action.payload.GisEdit;
      state.questions[action.payload.GindexQuestion].GisMandatory =
        action.payload.GisMandatory;
      state.questions[action.payload.GindexQuestion].GjsonConfiguration =
        action.payload.GjsonConfiguration;
      state.questions[action.payload.GindexQuestion].GnameQuestion =
        action.payload.GnameQuestion;
      state.questions[action.payload.GindexQuestion].Gorder =
        action.payload.Gorder;
      state.questions[action.payload.GindexQuestion].GvalidationText =
        action.payload.GvalidationText;

      return { ...state };

    case "UPDATE_QUESTIONS":
      state.questions[action.payload.GindexQuestion].GidCategoryQuestion =
        action.payload.GidCategoryQuestion;
      state.questions[action.payload.GindexQuestion].GisEdit =
        action.payload.GisEdit;
      state.questions[action.payload.GindexQuestion].GisMandatory =
        action.payload.GisMandatory;
      state.questions[action.payload.GindexQuestion].GjsonConfiguration =
        action.payload.GjsonConfiguration;
      state.questions[action.payload.GindexQuestion].GnameQuestion =
        action.payload.GnameQuestion;
      state.questions[action.payload.GindexQuestion].Gorder =
        action.payload.Gorder;
      state.questions[action.payload.GindexQuestion].GvalidationText =
        action.payload.GvalidationText;

      return { ...state };
    case "DELETE_QUESTIONS":
      return { ...state, questions: action.payload.questions };

    case "CANCEL_QUESTIONS":
      let state_cancel_questions = [...state.questions];
      state_cancel_questions[action.payload.GindexQuestion].GisEdit =
        action.payload.GisEdit;
      return { ...state, questions: state_cancel_questions };

    case "EDIT_QUESTIONS":
      let state_edit_questions = [...state.questions];
      state_edit_questions[action.payload.GindexQuestion].GisEdit =
        action.payload.GisEdit;
      return { ...state, questions: state_edit_questions };
    case "CLEAN_QUESTIONS":
      return { ...state, questions: [] };
    case "QUESTIONS_STYLE":
      return {
        ...state,
        globalStyle: { ...state.globalStyle, questions: action.payload },
      };
    case "ANSWERS_STYLE":
      return {
        ...state,
        globalStyle: { ...state.globalStyle, answers: action.payload },
      };
    case "CLEAN_STYLES":
      let styles = {
        questions: {},
        answers: {},
      };
      return { ...state, globalStyle: styles };
    case "UPDATE_QUESTIONS_DEPENDENCY":
      state.questions[action.payload.GindexQuestion].GisDependent =
        action.payload.GisDependent;
      state.questions[action.payload.GindexQuestion].GidParentQuestion =
        action.payload.GidParentQuestion;
      state.questions[action.payload.GindexQuestion].GdependentAnswer =
        action.payload.GdependentAnswer;
      return { ...state };
    case "CLONE_QUESTION":
      let questionArr = [];
      let updatedQueArr = [];
      questionArr = [...state.questions];
      updatedQueArr = questionArr.slice(0, action.payload.clonePosition);
      updatedQueArr.push(action.payload);
      questionArr.slice(action.payload.clonePosition).forEach((record) => {
        record.GindexQuestion = record.GindexQuestion + 1;
        record.Gorder = record.Gorder + 1;
        updatedQueArr.push(record);
      });
      return { ...state, questions: [...updatedQueArr] };
    case "ADD_ADDITIONAL_QUESTIONS":
      let stAdd = state;
      stAdd.additionalQuestions.push(action.payload);
      return { ...state, additionalQuestions: stAdd.additionalQuestions };
    case "SAVE_ADDITIONAL_QUESTIONS":
      state.additionalQuestions[
        action.payload.GindexQuestion
      ].GidCategoryQuestion = action.payload.GidCategoryQuestion;
      state.additionalQuestions[action.payload.GindexQuestion].GidQuestion =
        action.payload.GidQuestion;
      state.additionalQuestions[
        action.payload.GindexQuestion
      ].GidQuestionSurvey = action.payload.GidQuestionSurvey;
      state.additionalQuestions[action.payload.GindexQuestion].GisEdit =
        action.payload.GisEdit;
      state.additionalQuestions[action.payload.GindexQuestion].GisMandatory =
        action.payload.GisMandatory;
      state.additionalQuestions[
        action.payload.GindexQuestion
      ].GjsonConfiguration = action.payload.GjsonConfiguration;
      state.additionalQuestions[action.payload.GindexQuestion].GnameQuestion =
        action.payload.GnameQuestion;
      state.additionalQuestions[action.payload.GindexQuestion].Gorder =
        action.payload.Gorder;
      state.additionalQuestions[action.payload.GindexQuestion].GvalidationText =
        action.payload.GvalidationText;

      return { ...state };
    case "UPDATE_ADDITIONAL_QUESTIONS":
      state.additionalQuestions[
        action.payload.GindexQuestion
      ].GidCategoryQuestion = action.payload.GidCategoryQuestion;
      state.additionalQuestions[action.payload.GindexQuestion].GisEdit =
        action.payload.GisEdit;
      state.additionalQuestions[action.payload.GindexQuestion].GisMandatory =
        action.payload.GisMandatory;
      state.additionalQuestions[
        action.payload.GindexQuestion
      ].GjsonConfiguration = action.payload.GjsonConfiguration;
      state.additionalQuestions[action.payload.GindexQuestion].GnameQuestion =
        action.payload.GnameQuestion;
      state.additionalQuestions[action.payload.GindexQuestion].Gorder =
        action.payload.Gorder;
      state.additionalQuestions[action.payload.GindexQuestion].GvalidationText =
        action.payload.GvalidationText;

      return { ...state };
    case "EDIT_ADDITIONAL_QUESTIONS":
      let state_edit_additional_questions = [...state.additionalQuestions];
      state_edit_additional_questions[action.payload.GindexQuestion].GisEdit =
        action.payload.GisEdit;
      return { ...state, additionalQuestions: state_edit_additional_questions };
    case "DELETE_ADDITIONAL_QUESTIONS":
      return {
        ...state,
        additionalQuestions: action.payload.additionalQuestions,
      };
    case "CLEAN_ADDITIONAL_QUESTIONS":
      return { ...state, additionalQuestions: [] };
    case "CANCEL_ADDITIONAL_QUESTIONS":
      let state_cancel_additional_questions = [...state.additionalQuestions];
      state_cancel_additional_questions[action.payload.GindexQuestion].GisEdit =
        action.payload.GisEdit;
      return {
        ...state,
        additionalQuestions: state_cancel_additional_questions,
      };
    case "CLONE_ADDITIONAL_QUESTION":
      let additionalQuestionArr = [];
      let updatedAddQueArr = [];
      additionalQuestionArr = [...state.additionalQuestions];
      updatedAddQueArr = additionalQuestionArr.slice(
        0,
        action.payload.clonePosition
      );
      updatedAddQueArr.push(action.payload);
      additionalQuestionArr
        .slice(action.payload.clonePosition)
        .forEach((record) => {
          record.GindexQuestion = record.GindexQuestion + 1;
          record.Gorder = record.Gorder + 1;
          updatedAddQueArr.push(record);
        });
      return { ...state, additionalQuestions: [...updatedAddQueArr] };
    default:
      throw new Error("Unexpected action");
  }
};
